import {
  Unit_instance3vdlo4e4f5ggx as Unit_instance,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  HashMap1a0ld5kgwhmhv as HashMap,
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  VOID3gxj6tk5isa35 as VOID,
  Long2qws0ah9gnpki as Long,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
//endregion
//region block: pre-declaration
class RpcInternalConcurrentHashMap {}
function set(key, value) {
  this.d8l(key, value);
}
class SynchronizedHashMap {
  constructor() {
    var tmp = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp.k8l_1 = HashMap.s9();
  }
  d8l(key, value) {
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    return this.k8l_1.b5(key, value);
  }
  f8l(key, value, remappingFunction) {
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    var old = this.k8l_1.w4(key);
    var tmp;
    if (old == null) {
      // Inline function 'kotlin.collections.set' call
      this.k8l_1.b5(key, value);
      tmp = value;
    } else {
      var new_0 = remappingFunction(old, value);
      // Inline function 'kotlin.collections.set' call
      this.k8l_1.b5(key, new_0);
      tmp = new_0;
    }
    return tmp;
  }
  g8l(key, computeValue) {
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    var tmp0_elvis_lhs = this.k8l_1.w4(key);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = computeValue();
      // Inline function 'kotlin.collections.set' call
      this.k8l_1.b5(key, this_0);
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  r7c(key) {
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    return this.k8l_1.w4(key);
  }
  h8l(key) {
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    return this.k8l_1.c5(key);
  }
  a5() {
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.k8l_1.a5();
    return Unit_instance;
  }
  i8l(key) {
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    return this.k8l_1.u4(key);
  }
  x4() {
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    return this.k8l_1.x4();
  }
  y4() {
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    return this.k8l_1.y4();
  }
  j8l(block) {
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    return block(this.k8l_1.x4());
  }
}
class RpcInternalThreadLocal {
  constructor() {
    this.l8l_1 = RpcInternalConcurrentHashMap_0();
  }
  a1v() {
    var threadId = currentThreadId();
    return this.l8l_1.r7c(threadId);
  }
  m8l(value) {
    var threadId = currentThreadId();
    this.l8l_1.e8l(threadId, value);
  }
  s7() {
    var threadId = currentThreadId();
    this.l8l_1.h8l(threadId);
  }
}
//endregion
function getOrNull(_this__u8e3s4) {
  return !(_this__u8e3s4 == null) && _this__u8e3s4.z1m() ? _this__u8e3s4.z1o() : null;
}
function RpcInternalConcurrentHashMap_0(initialSize) {
  initialSize = initialSize === VOID ? 32 : initialSize;
  return new SynchronizedHashMap();
}
function currentThreadId() {
  return new Long(1, 0);
}
//region block: post-declaration
initMetadataForInterface(RpcInternalConcurrentHashMap, 'RpcInternalConcurrentHashMap');
protoOf(SynchronizedHashMap).e8l = set;
initMetadataForClass(SynchronizedHashMap, 'SynchronizedHashMap', SynchronizedHashMap, VOID, [RpcInternalConcurrentHashMap]);
initMetadataForClass(RpcInternalThreadLocal, 'RpcInternalThreadLocal', RpcInternalThreadLocal);
//endregion
//region block: exports
export {
  RpcInternalConcurrentHashMap_0 as RpcInternalConcurrentHashMap298ok532k8jut,
  RpcInternalThreadLocal as RpcInternalThreadLocal9wlt57iy5wdn,
  getOrNull as getOrNull367y7bf53uq6w,
};
//endregion
